import axios from "axios";
import { API_URL, BASE_URL } from "../../config";
import { setToken } from "../../utils/authManager";
import socketIOClient from "socket.io-client";
const socket = socketIOClient(BASE_URL);
export function loginWithPassword(formData) {
  return new Promise((resolve, reject) => {
    axios
      .post(`${API_URL}user/login`, formData)
      .then(async (response) => {
        socket.emit("join", { userId: response.data.userId });
        await setToken(response.data.token);
        console.log("In here")
        resolve(response.data);
      })
      .catch((err) => {
        reject(err);
      });
  });
}
export function _register(formData) {
  return new Promise((resolve, reject) => {
    axios
    .post(`${API_URL}user/register`, formData)
    .then(async (response) => {
      resolve(response.data);
    })
    .catch((err) => {
      reject(err);
    });
  });
}
export function _forgetPassword(formData) {
  return new Promise((resolve, reject) => {
    axios
    .post(`${API_URL}user/forget-password`, formData)
    .then(async (response) => {
      resolve(response.data);
    })
    .catch((err) => {
      reject(err);
    });
  });
}
export function _signup(formData) {
  return new Promise((resolve, reject) => {
    axios
    .post(`${API_URL}user/signup`, formData)
    .then(async (response) => {
      resolve(response.data);
    })
    .catch((err) => {
      reject(err);
    });
  });
}